// @flow
// Import modules
import React from 'react';
import ClassNames from 'classnames';
import { Button } from '@riseart/common';

// Import styles
import {
  quizQuestionOverlayCls,
  quizQuestionActiveCls,
  quizQuestionCls,
  quizQuestionTextCls,
  quizQuestionButtonCls,
  quizQuestionButtonBackCls,
  quizQuestionButtonNextCls,
} from 'shared_components/quiz/common/questions/Question.less';

type Props = {
  text: string,
  backButton: {
    translationText: string,
    url: string,
    backListener: Function,
  },
  nextButton: {
    translationText: string,
    url: string,
    nextListener: Function,
  },
  isActive: boolean,
  onAnswer: Function,
  error: Object,
};

/**
 * Quiz Info Question
 *
 * @param {Props} props
 * @returns {XML}
 */
export const QuizInfoQuestion = (props: Props) => {
  const tabIndex = props.isActive ? '0' : '-1';

  return (
    <div
      className={ClassNames(quizQuestionCls, {
        [quizQuestionActiveCls]: props.isActive,
      })}
    >
      <div className={quizQuestionOverlayCls} />
      <div className={quizQuestionTextCls}>{props.text}</div>
      <div className={quizQuestionButtonCls}>
        {props.backButton ? (
          <Button
            className={quizQuestionButtonBackCls}
            type="text"
            noBorder
            tabIndex={tabIndex}
            disabled={false}
            onClick={props.backButton.backListener}
          >
            {props.backButton.translationText}
          </Button>
        ) : null}

        {props.nextButton ? (
          <Button
            className={quizQuestionButtonNextCls}
            type="black"
            isBlackBorder
            tabIndex={tabIndex}
            disabled={!!props.error}
            onClick={props.nextButton.nextListener}
          >
            {props.nextButton.translationText}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
